import type { ConfigAlcadaNivel } from './models';

export interface FormAlcada { min: string; max: string; sla: string; justificativa: string }

const numero = (t: string): number => Number(t.trim().replace(/\./g, '').replace(',', '.'));

export const formDaAlcada = (a: ConfigAlcadaNivel): FormAlcada => ({
  min: a.valorMin ? String(a.valorMin).replace('.', ',') : '',
  max: a.valorMax != null ? String(a.valorMax).replace('.', ',') : '',
  sla: String(a.slaDiasUteis),
  justificativa: '',
});

/** Mesmas regras do backend para avisar antes de enviar (valor mínimo ≤ máximo, SLA ≥ 1 dia útil, justificativa). */
export const validarFormAlcada = (f: FormAlcada): string | null => {
  const min = f.min.trim() === '' ? 0 : numero(f.min);
  const max = f.max.trim() === '' ? null : numero(f.max);
  if (!Number.isFinite(min) || min < 0) return 'O valor mínimo deve ser um número maior ou igual a zero.';
  if (max !== null && (!Number.isFinite(max) || max < min)) return 'O valor máximo deve ser maior ou igual ao mínimo (ou deixe em branco para sem limite).';
  const sla = Number(f.sla);
  if (!Number.isInteger(sla) || sla < 1) return 'O SLA deve ser de pelo menos 1 dia útil.';
  if (!f.justificativa.trim()) return 'Informe a justificativa SOX.';
  return null;
};

/** Corpo do PUT: mantém tudo da alçada (cargo, escopo, titular, substituto) e troca só faixa de valor e SLA. */
export const pedidoAtualizarAlcada = (a: ConfigAlcadaNivel, f: FormAlcada) => ({
  etapaId: a.etapaId,
  cargoId: a.cargoId,
  scopeType: a.scopeType,
  scopeTenantIds: a.scopeType !== 'GROUP' ? a.scopeTenantIds : undefined,
  valorMinimo: f.min.trim() === '' ? undefined : numero(f.min),
  valorMaximo: f.max.trim() === '' ? undefined : numero(f.max),
  slaDiasUteis: Number(f.sla),
  titularId: a.titularId ?? undefined,
  substitutoId: a.substitutoId ?? undefined,
  justificativaSox: f.justificativa.trim(),
});

export const validarSlaEtapa = (sla: string, justificativa: string): string | null => {
  const n = Number(sla);
  if (!Number.isInteger(n) || n < 1) return 'O SLA deve ser de pelo menos 1 dia útil.';
  if (!justificativa.trim()) return 'Informe a justificativa SOX.';
  return null;
};

export const justificativaAlcadaEdicao = (a: ConfigAlcadaNivel): string =>
  `Ajuste da alçada do nível N${a.nivel} (${a.cargo}) conforme a política de aprovação e a segregação de funções.`;

export const justificativaSlaEtapa = (etapa: string, de: number | null, para: string): string =>
  `Ajuste do SLA da etapa "${etapa}"${de != null ? ` de ${de} para ${para || '—'} dia(s) útil(eis)` : ''}, conforme a Matriz de SLA do Fechamento.`;
